//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {BASIC} from "@/config/constant";
import promise from '@/axios/promise';
import {formatTime,guid,dateFormat} from "@/utils/common";
import {detailData,monthListData,saveData,approveDeal,getProjFbApplyCount} from '@/api/flyback/flyback';
import {getDicData,getPersonProjectData,getInnerUserData,getProvCityCascadeList} from '@/api/common/dic';
import {getProjPersonPlanDataByConditon} from '@/api/pm/budget';
import { Toast } from 'mint-ui';


// 省份数据，暂时固定，不然第一次进来的时候不会有省份数据
let provData = ["北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省", "吉林省", "黑龙江省", "上海市", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省", "河南省", "湖北省", "湖南省", "广东省", "广西壮族自治区", "海南省", "重庆市", "四川省", "贵州省", "云南省", "西藏自治区", "陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区"];
export default{
    name :'flybackApply',
    data(){
        return {
            taskId: this.$route.query.taskId,
            taskType: this.$route.query.taskType,
            taskTopic: this.$route.query.taskTopic,
            showConfirm:this.$route.query.showConfirm,
            businessKey:this.$route.query.businessKey,
            taskDefinitionKey:this.$route.query.taskDefinitionKey,
            taskVisible: false,
            taskHis:[],
            selects: [],
            columns: [/*{
                title: '账号',
                name: 'userName',
                width: 80,
                align: 'center'
              },*/
              {
                title: '名称',
                name: 'realName',
                align: 'center'
              }
            ],
            variables:{},
            msg:"",
            Index:0,
            status:"S",
            nextTaskDatas:[],

            // 标记是否为 编辑:1 或 查看:2
            flag:"2",
            // 申请还是折现
            type:"",
            // 标题
            title:'',
            // 申请或折现数据
            form:{},
            // 申请人员
            applyPerson:'',
            // 月份天数
            mDays:'',
            starDay:'',
            endDay:"",
            year:'',
            month:0,
            index:'',
            // 选中日期的flyback申请数据
            dataList:[],
            data:{
               // 月份所有的flyback申请数据
               flybackApprList:[],
               // 选中日期的申请数据
               dayApplyData:[],
               // 月份所有的日报填写信息
               dayReportList:[]
            },
            // 项目下拉数据
            projSelOptions:[],
            // 行程定义
            fbApplyTypeOptions:[],
            // 行程类型
            fbTravTypeOptions:[],
            // 交通类型
            trafficTypeOptions:[],
            // 预算中的人员信息
            projPersonInfo:{},
            // 省份城市数据
            cityData:{},
            openCitySelFlag:false,
            addressSlots: [
                {
                  width: '100%',
                  textAlign: 'right',
                  values: provData
                }, {
                  width: '100%',
                  textAlign: 'left',
                  values: ['北京市']
                }
            ],
            address:['北京市', '北京市'],
            addressProvince: '北京市',
            addressCity: '北京市',
            // 地址选择类型：1：出发地(往) 2：目的地(往) 3: 出发地(返) 4：目的地(返)
            addressSelType:'1',
            // 已申请次数
            applyQty:0,
        }
    },
    created(){
        // 字典表等数据
        this.dicFn();
        // 加载数据
        this.loadData();
    },
    mounted(){
    },
    methods:{
        //时间格式化
        dateFormatter(date) {
            return dateFormat(date);
        },
        //返回
        goBack(){
            //this.$router.push({path:'/'});
            this.$router.go(-1);
        },
        // 加载数据
        loadData(){
            var condition = {'applyId':this.businessKey};
            detailData(condition).then(response => {
                // 数据赋值
                this.form = response.flybackApply;
                this.showControl();
                if(this.form != null && this.form != undefined){
                    if(this.form.status === '被驳回'){
                        this.flag = '1';
                    }else{
                        this.flag = '2';
                    }
                    var apprDate = '';
                    if(this.form.flybackType === '申请'){
                        this.type = '1';
                        this.title = "差旅申请审批";
                        if(this.form.typeCode === '001'){
                            apprDate = this.form.planToTime;
                        }else if(this.form.typeCode === '002'){
                            apprDate = this.form.planBackTime;
                        }else if(this.form.typeCode === '003'){
                            apprDate = this.form.planToTime;
                        }
                    }else if(this.form.flybackType === '折现'){
                        this.type = '2';
                        this.title = "flyback折现审批";
                        apprDate = this.form.planToTime;
                    }

                    // 申请人员
                    this.applyPerson = this.form.crtUserCode;
                    // 获取整个月份的数据
                    this.getMonthData(apprDate);

                    // 获取已申请的次数
                    var crtDate = this.dateFormatter(new Date(this.form.crtTime));
                    var params = {'condition':{currCrtDate:crtDate,projId:this.form.projId,id:this.form.id,crtUserCode:this.form.crtUserCode}};
                    getProjFbApplyCount(params).then(response => {
                        this.applyQty = response;
                    });
                }
            });
        },
        // 界面显隐控制
        showControl(){
            // 已审批情况
            if(this.taskType === 'done'){
                $(".bottomNav").css('display','none');
            }
        },
        // 获取整个月份的数据
        getMonthData(date){
            date = new Date(date);
            var year =date.getFullYear();
            var month=date.getMonth()+1;
            var day=date.getDate();
            this.year=year;
            this.month=month;
            this.index=day;
            this.dateRech(this.year,this.month);
        },
        // 选中月份及选中日期的数据获取
        dateRech(year,month){
            // 获取月份的天数
            var dayNum=this.mGetDate(year,month);
            this.mDays=dayNum;
            // 防止月份没有那么大的日期
            if(this.index>dayNum){
                this.index = dayNum;
            }
            //当前月当天日期对象：
            var starDate=new Date(year, month, 0);
            //当前月第一天日期对象：
            starDate=new Date(starDate.setDate(1));
            //当前月第一天星期几:
            var weekday=starDate.getDay();
            this.starDay=weekday;
            this.dataList=[];
            // 获取选中月份的flyback申请数据
            this.getFlybackApplyByMonth();
            var total =42-parseInt(dayNum)-parseInt(weekday);
            if(total>=7){
                this.endDay=total-7;
            }else{
                this.endDay=total;
            }
        },
        //所在月份的数据
        getFlybackApplyByMonth(){
            // 选中的月份
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr;
            }

            // 年月
            var ym = this.year+'-'+monthStr;
            var userCode = this.applyPerson;
            // 获取选中月份所有的flyback申请数据
            var condition = {'condition':{'applyMonth':ym,'crtUserCode':this.applyPerson}};
            monthListData(condition).then(response => {
                // 获取本月所有的flyback申请数据
                this.data.flybackApprList=response.list;

                // 获取月份中的日报数据
                promise({
                    url:BASIC+'/dayReport/list/userMonth',
                    method:'get',
                    params:{month:ym,userCode:userCode}
                }).then(res=>{
                    if(res.code==0){
                        this.data.dayReportList=res.data;

                        // 更新日期中存在flyback申请、日报的显示
                        this.updateDateList();
                        // 获取选中日期的flyback申请数据
                        this.getInfo(this.index);
                    }
                });
            });
        },
        // 处理本月份存在flyback申请的显示
        updateDateList(){
            var maxDay=this.mDays;
            this.dataList=[];
            // 当前日期
            var currDate=new Date();
            for(var i=1;i<=maxDay;i++){
                var applyDataItem = {};
                // 日期
                applyDataItem.dateDay = i;

                // 人天补助获取

                var dayStr=i+"";
                if(i<10){
                    dayStr="0"+dayStr;
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr;
                }
                var date=this.year+'-'+monthStr+'-'+dayStr;
                var flybackApplys = [];
                this.data.flybackApprList.find((item) => {
                    //筛选出匹配数据
                    var applyDate=new Date(item.applyDate);
                    if(item.fbDate === date){
                        flybackApplys.push(item);
                    }
                });

                var statusClass="unReach";
                // ********flyback申请数据处理***************
                applyDataItem.applyData = [];
                if(flybackApplys!=null && flybackApplys!=undefined && flybackApplys.length>0){
                    flybackApplys.forEach(element => {
                        // flyback申请数据
                        var applyData={};
                        var status=element.status;
                        if(status=='被驳回'){
                            statusClass="refused";
                        }
                        if(status=='待审批'){
                            statusClass="wait";
                        }
                        if(status=='已通过'){
                            statusClass="success";
                        }
                        // 状态样式
                        applyData.statusClass=statusClass;
                        // 单边费用
                        applyData.perCost=element.perCost;
                        // 类型：申请、折现
                        applyData.flybackType=element.flybackType;
                        // 申请的往返类型
                        var applyType = "";
                        // 折现金额
                        var discountAmt = 0;
                        if(element.flybackType === '申请'){
                            // 申请情况下
                            applyType = element.fbType;
                        }else{
                            // 折现情况下
                            discountAmt = element.discountAmt;
                        }
                        // 申请往返类型
                        applyData.applyType = applyType;
                        // 折现金额
                        applyData.discountAmt = discountAmt;

                        applyDataItem.applyData.push(applyData);
                    });
                }

                // ******************日报数据处理 *******************
                // 工时
                var workHour=0;
                // 人天补助
                var workSubsidy=0;
                var status="已通过";
                // 日报统计数据
                var reportData={};
                var dayReport = this.data.dayReportList.find((item) => { //这里的userList就是上面遍历的数据源
                    var reportTime=new Date(item.reportTime) ;
                    return formatTime(reportTime,'yyyy-MM-dd') == date; //筛选出匹配数据
                });
                applyDataItem.dayReportData = [];
                if(dayReport!=null && dayReport!=undefined){
                    var refuseFlag=false;
                    var waitFlag=false;
                    dayReport.reportDetailList.forEach(element => {
                       workHour+=element.workHour;
                       workSubsidy+=element.workSubsidy; 
                       var status=element.status;
                       if(status=='被驳回'){
                            refuseFlag=true;
                       }
                       if(status=='待审批'){
                           waitFlag=true;
                       }
                    });
                    if(refuseFlag){
                        status="被驳回";
                        statusClass="refused";
                    }else if(waitFlag && !refuseFlag){
                        status="待审核";
                        statusClass="wait";
                    }else{
                        status="已通过";
                        statusClass="success";
                    }

                    reportData.statusClass=statusClass;
                    reportData.workHour=workHour;
                    reportData.workSubsidy=workSubsidy;
                    // 添加日报统计数据
                    applyDataItem.dayReportData.push(reportData);
                }

                this.dataList.push(applyDataItem);
            }
        },
        //日历点击查看当天
        getInfo(index){
            this.index=index;
            var self=this;
            var dayStr=this.index+"";
            if(index<10){
                dayStr="0"+dayStr
            }
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr
            }
            var date=this.year+'-'+monthStr+'-'+dayStr;
            this.data.dayApplyData=[];
            for(var i=0;i<this.data.flybackApprList.length;i++){
                var item = this.data.flybackApprList[i];
                if(item.fbDate === date){
                    this.data.dayApplyData.push(item);
                }
            }
        },
        getClass(index){
            if(index==this.index){
                return "checkedDay";
            }
            return "";
        },
        // 获取月份的天数
        mGetDate(year, month){
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        vueTouch:function(txt,e){
            if(txt=='左滑'){
                this.month+=1;
                if(this.month>12){
                    this.year+=1;
                    this.month=1;
                }
                this.dateRech(this.year,this.month);
            }else if(txt=='右滑'){
                this.month-=1;
                if(this.month<1){
                    this.year-=1;
                    this.month=12;
                }
                this.dateRech(this.year,this.month);
            }
        },
        // 项目选择改变事件
        projSelChange(value){
          var self = this;
          let obj = {};
          obj = self.projSelOptions.find((item)=>{
            return item.projCode === value;
          });
          self.form.projName = (obj===undefined?'':obj.projName);
          self.form.projId = (obj===undefined?'':obj.id);
          self.form.pmCode = (obj===undefined?'':obj.pmCode);
          self.form.pmName = (obj===undefined?'':obj.pmName);
          self.form.pdCode = (obj===undefined?'':obj.pdCode);
          self.form.pdName = (obj===undefined?'':obj.pdName);

          // 获取登陆人员预算人员计划数据
          self.getProjPersonPlanDataByConditon(obj.city);
        },
        // 获取登陆人员预算人员计划数据
        getProjPersonPlanDataByConditon(projAddress){
            // 获取登陆人员预算人员计划数据
            var condition = {projId:this.form.projId,personCode:'',personType:'1'};
            getProjPersonPlanDataByConditon(condition).then(response => {
                if(response != null && response.length>0){
                    this.projPersonInfo = response[0];
                    if(this.projPersonInfo != null && this.projPersonInfo != undefined){
                      this.form.baseAddress = this.projPersonInfo.city;
                      this.form.projAddress = projAddress;
                      this.form.transTypeCode = this.projPersonInfo.trafficTypeCode;
                      this.form.transTypeName = this.projPersonInfo.trafficTypeName;
                      this.form.perCost = this.projPersonInfo.perCost;
                    }
                }
            });
        },
        // 类型选择改变事件
        typeSelChange(value){
          let obj = {};
          obj = this.fbApplyTypeOptions.find((item)=>{
            return item.dicCode === value;
          });
          this.form.typeName = (obj===undefined?'':obj.dicName);
          if(value === '001'){
            // 到达目的地
            this.form.fromAddressBack = '';
            this.form.toAddressBack = '';
            this.form.planBackTime = null;
          }else if(value === '002'){
            // 返回base地
            this.form.fromAddressGo = '';
            this.form.toAddressGo = '';
            this.form.planToTime = null;
          }
        },
        // 检查必填项
        check(){
            // 项目
            if(this.form.projId === null || this.form.projId === undefined || this.form.projId === ''){
                Toast({
                  message: '请选择项目！',
                  position: 'middle',
                  duration: 1500,
                  className:'info'
                });
                return false;
            }

            // 单边费用
            if(this.form.perCost === null || this.form.perCost === undefined || this.form.perCost.toString().trim() === '' 
              || isNaN(this.form.perCost) || this.form.perCost.toString().indexOf(" ")>-1){
                Toast({
                  message: '请填写单边费用！',
                  position: 'middle',
                  duration: 1500,
                  className:'info'
                });
                return false;
            }
            // 申请
            if(this.type === '1'){

                if(this.form.typeCode === null || this.form.typeCode === undefined || this.form.typeCode === ''){
                    Toast({
                      message: '请选择行程定义！',
                      position: 'middle',
                      duration: 1500,
                      className:'info'
                    });
                    return false;
                }
                if(this.form.travType === null || this.form.travType === undefined || this.form.travType === ''){
                    Toast({
                      message: '请选择行程类型！',
                      position: 'middle',
                      duration: 1500,
                      className:'info'
                    });
                    return false;
                }

                if(this.form.typeCode === '001' || this.form.typeCode === '003'){
                    if(this.form.fromAddressGo===null || this.form.fromAddressGo===undefined || this.form.fromAddressGo===''
                        || this.form.toAddressGo===null || this.form.toAddressGo===undefined || this.form.toAddressGo===''){
                        Toast({
                          message: '请选择出发地(到达)或目的地(到达)！',
                          position: 'middle',
                          duration: 1500,
                          className:'info'
                        });
                        return false;
                    }
                    if(this.form.planToTime===null || this.form.planToTime===undefined || this.form.planToTime===''){
                        Toast({
                          message: '请选择出发时间！',
                          position: 'middle',
                          duration: 1500,
                          className:'info'
                        });
                        return false;
                    }
                }

                if(this.form.typeCode === '002' || this.form.typeCode === '003'){
                    if(this.form.fromAddressBack===null || this.form.fromAddressBack===undefined || this.form.fromAddressBack===''
                        || this.form.toAddressBack===null || this.form.toAddressBack===undefined || this.form.toAddressBack===''){
                        Toast({
                          message: '请选择出发地(返回)或目的地(返回)！',
                          position: 'middle',
                          duration: 1500,
                          className:'info'
                        });
                        return false;
                    }
                    if(this.form.planBackTime===null || this.form.planBackTime===undefined || this.form.planBackTime===''){
                        Toast({
                          message: '请选择返回时间！',
                          position: 'middle',
                          duration: 1500,
                          className:'info'
                        });
                        return false;
                    }
                }
            }
            
            // 折现
            if(this.type === '2'){
                if(this.form.planToTime===null || this.form.planToTime===undefined || this.form.planToTime===''
                    || this.form.planBackTime===null || this.form.planBackTime===undefined || this.form.planBackTime===''){
                    Toast({
                      message: '请选择往返回时间！',
                      position: 'middle',
                      duration: 1500,
                      className:'info'
                    });
                    return false;
                }
                if(this.form.discountAmt === null || isNaN(this.form.discountAmt) || this.form.discountAmt.toString().trim() === '' 
                    || this.form.discountAmt === undefined || this.form.discountAmt.toString().indexOf(" ")>-1){
                    Toast({
                      message: '请填写折现金额！',
                      position: 'middle',
                      duration: 1500,
                      className:'info'
                    });
                    return false;
                }
            }

            return true;
        },
        // 提交
        submitClick(){
            debugger
            // 判断必填字段是否填写
            var checkFlag = this.check();
            if(checkFlag){
                var flybackApplyData = JSON.stringify(this.form);
                var condition = {flybackApplyData:flybackApplyData,flag:this.flag,isSubmit:1};
                saveData(condition).then(response => {
                    if(response.flag === 'S'){
                        // 提交情况下
                        Toast({
                          message: '提交成功！',
                          position: 'middle',
                          duration: 1500,
                          className:'success'
                        });
                        // 返回列表界面
                        this.goBack();
                    }else{

                        Toast({
                          message: '提交失败：'+response.msg,
                          position: 'middle',
                          duration: 1500,
                          className:'warning'
                        });
                    }
                });
            }
        },
        addressChange(value, index) {
          switch (index) {
            case 0:
              this.addressProvince = value;
              const arr = this.cityData[value];
              this.addressSlots[1].values = arr;
              this.addressCity = arr[0];
              break;
            case 1:
              this.addressCity = value;
              break;
          }
          this.address = [this.addressProvince, this.addressCity]
        },
        // 交通类型改变事件
        changeTrafficTypeEvent(value){
          let obj = {};
          obj = this.trafficTypeOptions.find((item)=>{
            return item.dicCode === value;
          });
          this.form.transTypeName = (obj===undefined?'':obj.dicName);
        },
        cityClick(type){
            this.openCitySelFlag = true;
            this.addressSelType = type;
        },
        // 城市确认事件
        cityConfirmClick(){
            this.openCitySelFlag = false;

            if(this.addressSelType === '1'){
                // 出发地 往
                this.form.fromAddressGo = this.addressCity;
            }else if(this.addressSelType === '2'){
                // 目的地 往
                this.form.toAddressGo = this.addressCity;
            }else if(this.addressSelType === '3'){
                // 出发地 返
                this.form.fromAddressBack = this.addressCity;
            }else if(this.addressSelType === '4'){
                // 目的地 返
                this.form.toAddressBack = this.addressCity;
            }
        },
        // 字典表等数据
        dicFn(){
            // flyback行程定义
            var condition = {'cateCode':'flybackApplyType'};
            getDicData(condition).then(response => {
              this.fbApplyTypeOptions = response;
            });
            // flyback行程类型
            var condition = {'cateCode':'travType'};
            getDicData(condition).then(response => {
              this.fbTravTypeOptions = response;
            });

            // flyback行程类型
            var condition = {'cateCode':'travType'};
            getDicData(condition).then(response => {
              this.fbTravTypeOptions = response;
            });
            // 获取登录人员的项目信息，personCode='' 取登录人员项目
            condition = {personCode:''};
            getPersonProjectData(condition).then(response => {
              this.projSelOptions = response.list;
            });

            // 交通类型
            condition = {'cateCode':'trafficType'};
            getDicData(condition).then(response => {
              this.trafficTypeOptions = response;
            });

            // 获取省份城市级联数据
            condition = {type:'prov'};
            getProvCityCascadeList(condition).then(response => {
                this.provCityDeal(response);
            });
        },
        // 省份、城市处理
        provCityDeal(data){
            this.cityData = [];
            //provData = [];
            for(var i=0;i<data.length;i++){
                var item = data[i];
                // 省份数据
                //provData.push(item.name);
                // 城市
                var cities = item.cities;
                var cityArr = new Array();
                for(var j=0;j<cities.length;j++){
                    cityArr.push(cities[j].name);
                }
                this.cityData[item.name] = cityArr;
            }
        },

        /***************************审批相关*****************************/

        closeAlertDialog() {
            this.taskVisible = false;
        },

      // 通过
      agreeTask:function(){
        this.status="S";
        this.variables.status=this.status;
        if(this.showConfirm==0){
          this.taskVisible=true;
          this.getNextTaskDatas();
        }else{
          this.completeTask();
        }     
      },
      // 驳回
      refuseTask:function(){
        this.status="E";
        this.variables.status=this.status;
        this.taskVisible=true;
        this.getNextTaskDatas();
      },
      completeTask:function(){
        var map={};
        map.variables=this.variables;
        promise({
          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
          method:"post",
          headers:{"Content-Type": "application/json" },
          data:JSON.stringify(map),
        }).then(res=>{
            if(res.code==0){
              this.taskVisible=false;
              // 数据处理
              this.approveDeal();
             }else{
                // Message({message:res.msg,type:"error"});
             }
        });
      },
      IndexClick:function(index){
        this.Index=index;
      },
      taskConfirm:function(){
        //获取页面传递过来的变量
        var map={};
        //审核意见
        //循环获取每个任务的办理人和任务主题
        var topics={};
        var variables=this.variables;
        var flag=0;//0正常 1任务配置 2任务主题 3办理人
        var msg="";
        $.each(this.nextTaskDatas,function(index,row){
          var task=row.task;
          var taskKey=task.taskDefinitionKey;
          var taskName=task.taskName;
          var actDicTask= row.actDicTask;
          if(taskKey!='end'){
            if(actDicTask==null){
              flag=1;
              msg="请配置该流程的"+taskName+"节点任务信息";
              return;
            }else if(actDicTask.taskType==null || actDicTask.taskType==''){
              flag=1;
              msg="请配置该流程的"+taskName+"节点任务任务类型";
              return;
            }else if(actDicTask.userExpKey==null || actDicTask.userExpKey==''){
              flag=1;
              msg="请配置该流程的"+taskName+"节点任务办理人方式";
              return;
            }else{
              //设置任务主题
              var taskTopic=task.taskTopic;
              if(taskTopic==null || taskTopic==''){
                flag=2;
                msg=taskName+"节点任务主题不能为空";
                return;
              }
              topics[taskKey]=taskTopic;
              //任务办理人
              var taskType=actDicTask.taskType;
              var userExpKey=actDicTask.userExpKey;
              var data =[];
              var checkedUsers=row.checkedUsers;
              if(checkedUsers!=null && checkedUsers.length>0){
                $.each(row.users,function(index,user){
                  $.each(checkedUsers,function(index1,userIndex){
                    if(userIndex==index){
                      data.push(user);
                    }
                  });
                });
              }
              if(taskType=='Multi'){
                if(data==null || data.length==0){
                  flag=3;
                  msg=taskName+"节点任务办理人不能为空";
                  return;
                }else {
                  var userVal="";
                  for (var i = 0; i < data.length; i++) {
                    var user=data[i];
                    if(i==0){
                      userVal+=user.userName;
                    }else{
                      userVal=userVal+","+user.userName
                    }
                  }
                  variables[userExpKey]=userVal;
                }
              }else{
                if(data==null || data.length==0){
                  flag=3;
                  msg=taskName+"节点任务办理人不能为空";
                  return;
                }else if(data.length>1){
                  flag=3;
                  msg=taskName+"节点为单人任务";
                  return;
                }else{
                  variables[userExpKey]=data[0].userName;
                }
              }
            }
          }else{
            var taskTopic=task.taskTopic;
            if(taskTopic==null || taskTopic==""){
              taskTopic="结束"
            }
            topics.end=taskTopic;
          }
        });
        if(flag!=0){
          // Message({message:msg,type:"error"});
          return;
        }
        //任务主题
        //设置流程办理人
        map.taskTopics=topics;
        map.variables=variables;
        this.taskVisible=false;
        promise({
          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
          method:"post",
          headers:{"Content-Type": "application/json" },
          data:JSON.stringify(map),
        }).then(res=>{
            if(res.code==0){
              this.taskVisible=false;
              // 数据处理
              this.approveDeal();
             }else{
                // Message({message:res.msg,type:"error"});
             }
        });
      },
      // 审批通过后的数据处理
      approveDeal(){
        var taskKey = this.taskDefinitionKey;
        var data = {'taskId':this.businessKey,'isPass':this.status,'taskKey':taskKey,'projCode':this.form.projCode,
        'projName':this.form.projName,'reimCostNumb':this.form.discountAmt,'flybackType':this.form.flybackType};
        approveDeal(data).then(response => {
            if(response.flag === 'S'){
                Toast({
                  message: '操作成功！',
                  position: 'middle',
                  duration: 1500,
                  className:'success'
                });
                this.goBack();
            }else{
                Toast({
                  message: '数据处理失败：'+response.msg,
                  position: 'middle',
                  duration: 1500,
                  className:'warning'
                });
            }
        });
      },
      getTaskTopic:function(task,taskTopicExp){
        if(task!=null){
          var commitUser=task.commitUser;
          if(commitUser==null || commitUser==''){
            status='F';
          }
        }
        var taskTopic='';
        if(taskTopicExp==null || taskTopicExp==''){
          taskTopic=task.processDefinitionName+":"+task.taskName+":"+task.commitUserName;
        }else{
          var expArr=taskTopicExp.split(":");
          for (var i = 0; i < expArr.length; i++) {
            var exp=expArr[i];
            if(i==expArr.length-1){
              if(exp==null || exp==''){
                continue;
              }else if(exp=="procName"){
                taskTopic=taskTopic+task.processDefinitionName;
              }else if(exp=="taskName"){
                taskTopic=taskTopic+task.taskName;
              }else if(exp=="commitUser"){
                taskTopic=taskTopic+task.commitUserName;
              }else{
                var expVal=$("#"+exp).val();
                if(expVal!=undefined && expVal!=null && expVal!=""){
                 taskTopic=taskTopic+expVal;
                }
              }
            }else{
              if(exp==null || exp==''){
                continue;
              }else if(exp=="procName"){
                taskTopic=taskTopic+task.processDefinitionName+":";
              }else if(exp=="taskName"){
                taskTopic=taskTopic+task.taskName+":";
              }else if(exp=="commitUser"){
                taskTopic=taskTopic+task.commitUserName+":";
              }else{
                var expVal=$("#"+exp).val();
                if(expVal!=undefined && expVal!=null && expVal!=""){
                  taskTopic=taskTopic+expVal+":";
                }
              }
            }
          }
        }
        return taskTopic;
      },
      getNextTaskDatas:function(){
        var str=JSON.stringify(this.variables);
        promise({
          url:BASIC+"/task/getConfirmInfo?taskId="+this.taskId+"&status="+this.status,
          method:"post",
          headers:{"Content-Type": "application/json" },
          data:str
        }).then(res=>{
          var code =res.code;
          if(code==0){
            this.nextTaskDatas=res.data;
            var self=this;
            $.each(this.nextTaskDatas,function(index,row){
              var taskTpc = '';
              if(row.actDicTask !== null){
                taskTpc = row.actDicTask.taskTopic;
              }
              var taskTopic=self.getTaskTopic(row.task,taskTpc);
              row.task.taskTopic=taskTopic;
            });
          }else{
          }
         });
      },

    },
    filters:{
        statusFilter(val){
            if(val=='已通过'){
                return 'successStatus';
            }
            if(val=='被驳回'){
                return 'refuseStatus';
            }
            if(val=='待审批'){
                return 'waitStatus';
            }
        },
        dateFilter(val){
            if(val==null || val==""){
                return "";
            }
            return formatTime(val,'yyyy年MM月dd日');
        },
        timeFilter(val){
            if(val==null || val==""){
                return "";
            }
            return formatTime(val,'hh:mm');
        },

    }
}



// WEBPACK FOOTER //
// ./src/view/flyback/flybackApproval.vue